import React from 'react';
import { motion } from 'framer-motion';
import Card from './AnimatedCard';

interface FeatureCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  delay?: number;
}

const FeatureCard: React.FC<FeatureCardProps> = ({
  title,
  description,
  icon,
  delay = 0,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: delay * 0.1 }}
      viewport={{ once: true }}
    >
      <Card className="h-full p-6" interactive>
        <div className="text-primary-600 mb-4 inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary-50">
          {icon}
        </div>
        <h3 className="text-xl font-semibold mb-2">{title}</h3>
        <p className="text-neutral-600">{description}</p>
      </Card>
    </motion.div>
  );
};

export default FeatureCard;